export const Descope = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="0 0 196 216"
      xmlSpace="preserve"
    >
      <path
        fill="#0198B8"
        d="M66.841 183.009c.049 4.355.097 8.71-.27 13.485-11.818-6.767-23.167-14.04-34.66-21.077-3.023-1.85-6.494-2.968-9.759-4.421-1.994-5.399-3.99-10.797-5.564-16.59 2.378.369 4.526.837 6.264 1.947 12.42 7.933 24.72 16.054 37.157 23.961 2.028 1.29 4.543 1.816 6.832 2.695z"
        opacity="1"
      ></path>
      <path
        fill="#0BE5DA"
        d="M56.298 102c.85-.912 1.624-2.505 2.565-2.611 3.038-.343 6.137-.139 9.679.29 1.212 1.44 1.753 2.758 2.736 3.396 17.255 11.216 34.541 22.386 51.898 33.444 1.855 1.182 4.195 1.604 6.31 2.38-.19 1.28.077 3.15-.662 3.723-1.792 1.39-4.052 2.174-6.483 2.884-1.164-1.446-1.731-2.93-2.809-3.643-7.175-4.742-14.43-9.367-21.72-13.934-4.877-3.057-9.855-5.954-14.788-8.923-1.091-.413-2.182-.827-3.71-1.653-7.963-5.393-15.49-10.373-23.016-15.353z"
        opacity="1"
      ></path>
      <path
        fill="#13E5D1"
        d="M129.377 138.545c-2.006-.422-4.346-.844-6.201-2.026-17.357-11.058-34.643-22.228-51.898-33.444-.983-.638-1.524-1.957-2.285-3.3 3.358-.406 6.73-.473 10.563-.1 1.243 1.615 1.78 3.14 2.856 3.903 3.597 2.547 7.509 4.656 11.063 7.256 2.387 1.748 4.374 4.043 6.254 6.143-.431.113-.606.145-.713.247-.096.092-.118.261-.172.397l5.186 1.336c1.656.136 3.312.279 4.968.406 7.268.557 12.628 3.671 15.482 10.766 1.153 2.866 3.167 5.386 4.897 8.416z"
        opacity="1"
      ></path>
      <path
        fill="#07E4E3"
        d="M82.727 119.17a257.804 257.804 0 0115.086 8.759c7.29 4.567 14.544 9.192 21.719 13.934 1.078.713 1.645 2.197 2.45 3.691-2.826 1.962-5.652 3.557-9.194 5.557-2.288-4.191-4.438-7.98-6.446-11.841-3.98-7.655-7.928-7.877-13.248-.74-5.877-3.234-11.26-6.38-16.642-9.524 1.993-3.225 3.986-6.449 6.275-9.837z"
        opacity="1"
      ></path>
      <path
        fill="#57DB45"
        d="M180.423 56.014c.762 2.732 1.524 5.464 1.853 8.58-1.646-.019-3-.2-4.05-.863-9.341-5.915-18.569-12.013-27.954-17.857-6.12-3.811-12.448-7.29-18.682-10.92-.078-2.364-.156-4.729.227-7.511 11.469 6.52 22.417 13.556 33.511 20.353 4.879 2.989 10.054 5.493 15.095 8.218z"
        opacity="1"
      ></path>
      <path
        fill="#06A3BE"
        d="M66.914 182.573c-2.362-.443-4.877-.97-6.905-2.259-12.437-7.907-24.737-16.028-37.157-23.96-1.738-1.11-3.886-1.58-6.217-2.344-.464-.472-.555-.944-.662-2.2.014-2.802.045-4.819.445-6.821 4.9 2.647 9.35 5.428 13.983 7.865 3.738 1.966 7.696 3.516 11.557 5.25 5.502 9.625 13.99 15.097 25.029 17.64 0 2.146 0 4.27-.073 6.83z"
        opacity="1"
      ></path>
      <path
        fill="#088FB2"
        d="M22.181 171.339c3.236 1.11 6.707 2.227 9.73 4.078 11.493 7.036 22.842 14.31 34.591 21.536.346 1.483.346 2.924.346 4.552-19.021-2.271-32.731-12.099-42.868-27.5-.534-.811-1.177-1.55-1.799-2.666z"
        opacity="1"
      ></path>
      <path
        fill="#5CDB3C"
        d="M180.408 55.677c-5.026-2.388-10.201-4.892-15.08-7.881-11.094-6.797-22.042-13.833-33.376-20.778-.418-2.055-.51-4.103-.145-6.568 1.673.084 3 .414 4.09 1.112 10.474 6.71 20.862 13.554 31.389 20.18 2.318 1.459 5.084 2.206 7.644 3.281 1.821 3.44 3.642 6.878 5.478 10.654z"
        opacity="1"
      ></path>
      <path
        fill="#59DD55"
        d="M131.458 35.376c6.366 3.207 12.693 6.687 18.814 10.498 9.385 5.844 18.613 11.942 27.954 17.857 1.05.664 2.404.844 3.974 1.244.501 2.046.646 4.098.38 6.545-7.279-3.892-14.065-8.316-21.058-12.385-2.192-1.275-4.942-1.59-7.436-2.346-5.384-3.857-10.328-8.777-16.286-11.25-5.178-2.148-7.703-4.195-6.342-10.163z"
        opacity="1"
      ></path>
      <path
        fill="#01E3E3"
        d="M15.447 90.994c-.065-4.355-.131-8.71.255-13.521 2.615.575 4.824 1.524 6.932 2.657 5.425 2.916 10.805 5.913 16.203 8.878.046 4.358.092 8.716-.295 13.527-3.835-1.435-7.207-3.382-10.647-5.197-4.118-2.173-8.296-4.234-12.448-6.344z"
        opacity="1"
      ></path>
      <path
        fill="#22E3B4"
        d="M100.982 92.49c-5.371.802-10.758 1.513-16.107 2.443-2.781.484-4.543-.264-5.988-2.802-3.166-5.56-6.618-10.957-10.33-17.038 2.094-1.064 3.92-1.994 6.137-2.627 1.35 1.37 2.138 2.71 3.302 3.476 6.054 3.99 12.27 7.737 18.282 11.79 1.813 1.222 3.15 3.153 4.704 4.759z"
        opacity="1"
      ></path>
      <path
        fill="#66DB3A"
        d="M174.883 44.68c-2.513-.732-5.279-1.48-7.597-2.938-10.527-6.626-20.915-13.47-31.39-20.18-1.09-.698-2.416-1.028-3.964-1.533-1.176-3.157-.493-4.067 3.096-3.379 17.434 3.343 30.305 13.045 39.855 28.03z"
        opacity="1"
      ></path>
      <path
        fill="#07E4E3"
        d="M173.516 175.205c-2.971 3.499-5.943 6.998-9.27 10.29-4.452-3.19-8.447-6.328-12.682-9.1-2.676-1.75-5.71-2.954-8.585-4.403 3.165-2.552 6.33-5.105 10.158-7.814 2.674.924 4.708 1.962 6.688 3.095 4.578 2.62 9.13 5.285 13.691 7.932z"
        opacity="1"
      ></path>
      <path
        fill="#19E3BC"
        d="M128.157 117.563c-5.08.066-10.162.133-15.708-.24-1.486-1.621-2.32-3.067-3.56-3.937-4.746-3.333-9.7-6.372-14.403-9.762-1.448-1.044-2.341-2.857-3.488-4.318 5.015-.057 10.03-.114 15.524.242 1.13 1.272 1.615 2.373 2.46 2.95 4.987 3.41 10.154 6.566 15.047 10.101 1.69 1.22 2.77 3.285 4.128 4.964z"
        opacity="1"
      ></path>
      <path
        fill="#26E2A8"
        d="M101.374 92.561c-1.947-1.676-3.283-3.607-5.096-4.83-6.011-4.052-12.228-7.798-18.282-11.789-1.164-.767-1.951-2.106-2.947-3.525 2.391-1.668 4.817-2.992 7.748-4.059 2.898 1.398 5.29 2.537 7.683 3.677 1.158 2.159 2.405 4.276 3.453 6.487 1.481 3.128 3.688 4.935 8.075 4.528 3.838 2.53 6.91 5.09 9.981 7.649-3.408.644-6.815 1.289-10.615 1.862z"
        opacity="1"
      ></path>
      <path
        fill="#52DD5A"
        d="M154.217 57.132c2.363.412 5.113.728 7.305 2.003 6.993 4.069 13.78 8.493 20.991 12.823.386 3.074.426 6.106.057 9.544-8.285-4.232-16.162-8.87-24.038-13.508a10797.74 10797.74 0 01-4.315-10.862z"
        opacity="1"
      ></path>
      <path
        fill="#00CFD8"
        d="M16.05 144.975c-.032 2.016-.063 4.033-.11 6.474-.266-1.494-.726-3.41-.731-5.328-.036-15.064.016-30.13.484-45.645 2.058.335 3.731 1.02 5.277 1.925 5.976 3.495 11.912 7.06 17.863 10.6.047 2.703.095 5.406-.273 8.51-7.515-3.888-14.615-8.178-22.472-12.926 0 3.858 0 6.64-.026 9.87-.011 3.147.004 5.844-.011 8.991-.014 3.152.002 5.853-.008 9.004-.015 3.14-.004 5.833.006 8.525z"
        opacity="1"
      ></path>
      <path
        fill="#22E2AA"
        d="M112.026 99.266c3.355-.08 6.71-.16 10.58.153 7.661 4.795 14.808 9.196 21.955 13.596v4.757c-3.706 0-7.16 0-11.087-.418-1.152-1.264-1.678-2.334-2.536-2.918-5.006-3.407-10.197-6.553-15.088-10.114-1.635-1.19-2.57-3.343-3.824-5.056z"
        opacity="1"
      ></path>
      <path
        fill="#0BE5DA"
        d="M38.909 88.559c-5.47-2.516-10.85-5.513-16.275-8.429-2.108-1.133-4.317-2.082-6.836-3.111-.392-3.025-.428-6.053-.01-9.536 2.605.583 4.8 1.543 6.903 2.674 5.414 2.913 10.786 5.902 16.176 8.86.038 3.03.076 6.062.042 9.542z"
        opacity="1"
      ></path>
      <path
        fill="#04D9DF"
        d="M142.637 172.105c3.216 1.336 6.251 2.54 8.927 4.29 4.235 2.772 8.23 5.91 12.376 9.23-1.94 2.225-3.928 4.112-6.416 5.68-2.805-2.126-5.087-3.967-7.423-5.736-4.688-3.55-9.406-7.062-14.111-10.59 2.101-.92 4.203-1.841 6.647-2.874z"
        opacity="1"
      ></path>
      <path
        fill="#07E4E3"
        d="M56.216 102.46c7.609 4.52 15.135 9.5 22.722 14.795-7.345.314-14.751.314-22.804.314 0-4.869 0-9.758.082-15.108z"
        opacity="1"
      ></path>
      <path
        fill="#00D9DE"
        d="M38.904 112.552c-6.022-3.09-11.958-6.656-17.934-10.151-1.546-.904-3.22-1.59-5.178-2.382-.41-2.718-.475-5.43-.443-8.582 4.25 1.667 8.428 3.728 12.546 5.9 3.44 1.816 6.812 3.763 10.576 5.658.41 3.04.456 6.074.433 9.557z"
        opacity="1"
      ></path>
      <path
        fill="#02ABC3"
        d="M16.418 144.989c-.38-2.706-.39-5.398-.012-8.534 2.24.512 4.135 1.395 5.936 2.439 5.769 3.34 11.503 6.74 17.25 10.117.75 2.772 1.498 5.544 2.306 8.705-3.801-1.346-7.759-2.896-11.497-4.862-4.633-2.437-9.084-5.218-13.983-7.865z"
        opacity="1"
      ></path>
      <path
        fill="#14E4C7"
        d="M90.544 99.234c1.6 1.533 2.494 3.346 3.942 4.39 4.703 3.39 9.657 6.43 14.404 9.762 1.239.87 2.073 2.316 3.106 3.838-2.395.419-4.804.497-7.903.314-1.82-.378-2.949-.495-4.078-.611-2.166-2.05-4.153-4.345-6.54-6.093-3.554-2.6-7.466-4.71-11.063-7.256-1.077-.763-1.613-2.288-2.409-3.804 3.355-.43 6.722-.521 10.541-.54z"
        opacity="1"
      ></path>
      <path
        fill="#00BDCD"
        d="M16.08 126.997c-.014-2.698-.029-5.395.343-8.539 2.267.537 4.164 1.488 6.024 2.508 5.47 2.998 10.925 6.023 16.386 9.038.048 3.032.096 6.064-.268 9.501-7.769-3.9-15.127-8.204-22.484-12.508z"
        opacity="1"
      ></path>
      <path
        fill="#14E4C7"
        d="M39.985 66.998c-.326 2.73-.653 5.46-1.395 8.557-1.717-.33-3.022-1.016-4.317-1.721-6.023-3.282-12.043-6.569-18.064-9.854.57-2.436 1.14-4.873 2.25-7.643a29.74 29.74 0 017.06 2.707c4.853 2.594 9.648 5.296 14.466 7.954z"
        opacity="1"
      ></path>
      <path
        fill="#02B4C8"
        d="M16.05 127.446c7.388 3.855 14.746 8.16 22.445 12.509.642 2.778.942 5.511 1.17 8.65-5.82-2.971-11.554-6.371-17.323-9.711-1.801-1.044-3.695-1.927-5.91-2.888-.379-2.707-.395-5.408-.381-8.56z"
        opacity="1"
      ></path>
      <path
        fill="#00C6D3"
        d="M38.904 129.564c-5.532-2.575-10.987-5.6-16.457-8.598a74.807 74.807 0 00-5.998-2.956c-.36-2.785-.36-5.567-.36-9.425 7.856 4.748 14.956 9.038 22.4 13.372.391 2.418.439 4.792.415 7.607z"
        opacity="1"
      ></path>
      <path
        fill="#19E3BC"
        d="M159.333 145.996c0-2.371 0-4.742.456-7.537 2.769.814 5.081 2.052 7.395 3.286 5.17 2.758 10.34 5.513 15.511 8.27-.218 2.093-.435 4.186-1.201 6.632-2.487-.413-4.517-1.009-6.349-1.978-5.313-2.81-10.547-5.771-15.812-8.673z"
        opacity="1"
      ></path>
      <path
        fill="#36E087"
        d="M43.012 25.04c1.452-.952 2.904-1.903 4.846-2.6 6.652 4.024 12.816 7.791 18.98 11.558-.346 3.21-.692 6.42-1.446 9.266-1.63-1.61-2.685-3.108-4.105-4.06-4.952-3.319-10.12-6.323-15.008-9.73-1.426-.994-2.196-2.93-3.267-4.434z"
        opacity="1"
      ></path>
      <path
        fill="#22E2AA"
        d="M182.848 137.005c.043 2.042.085 4.084-.298 6.554-5.814-2.777-11.152-6.073-16.617-9.141-1.954-1.097-4.217-1.646-6.338-2.445-.083-2.362-.166-4.724.204-7.511 1.925.273 3.46.865 4.857 1.688 6.086 3.582 12.132 7.23 18.192 10.855z"
        opacity="1"
      ></path>
      <path
        fill="#10D2DA"
        d="M135.591 174.997c5.104 3.51 9.822 7.021 14.51 10.572 2.336 1.769 4.618 3.61 7.07 5.788-1.752 1.637-3.65 2.903-5.878 3.865-6.792-4.604-13.253-8.903-19.714-13.201-.304-3.114-1.881-6.883 4.012-7.024z"
        opacity="1"
      ></path>
      <path
        fill="#2EE29A"
        d="M182.85 123.001c.044 2.044.088 4.087-.298 6.559-2.865-.817-5.323-2.023-7.734-3.316-5.092-2.732-10.158-5.51-15.235-8.268-.083-2.367-.165-4.733.205-7.523 1.196-.108 1.986.128 2.677.533 6.804 3.99 13.593 8.006 20.386 12.015z"
        opacity="1"
      ></path>
      <path
        fill="#34E192"
        d="M42.672 25.09c1.41 1.454 2.181 3.39 3.607 4.384 4.889 3.407 10.056 6.411 15.008 9.73 1.42.952 2.475 2.45 3.713 4.031a22.66 22.66 0 01-6.684 2.299c-1.223-1.3-1.863-2.572-2.894-3.245-6.364-4.15-12.816-8.163-19.239-12.223 2.05-1.641 4.1-3.283 6.489-4.975z"
        opacity="1"
      ></path>
      <path
        fill="#2EE29A"
        d="M35.89 30.195a473.368 473.368 0 0119.532 12.094c1.031.673 1.67 1.946 2.525 3.284-1.092.995-2.22 1.647-4.042 2.354a312.328 312.328 0 01-19.87-11.69c-.703-.449-.679-2.038-.991-3.097.85-.94 1.7-1.878 2.845-2.945z"
        opacity="1"
      ></path>
      <path
        fill="#3CDF74"
        d="M182.838 95.002c.044 2.044.087 4.087-.3 6.558-3.87-1.491-7.28-3.461-10.755-5.314-4.021-2.144-8.098-4.185-12.151-6.27-.091-2.039-.182-4.078.203-6.542a33.016 33.016 0 018.01 3.094c5.042 2.744 10 5.64 14.993 8.474z"
        opacity="1"
      ></path>
      <path
        fill="#38DF7C"
        d="M159.495 90.398c4.19 1.663 8.267 3.704 12.288 5.848 3.474 1.853 6.886 3.823 10.687 5.747.41 2.048.456 4.09.076 6.562-3.872-1.488-7.29-3.459-10.77-5.313-4.032-2.148-8.117-4.193-12.179-6.283-.08-2.046-.159-4.092-.102-6.56z"
        opacity="1"
      ></path>
      <path
        fill="#04D9DF"
        d="M76.254 129.3c5.58 2.85 10.963 5.996 16.54 9.41-.633 2.14-1.462 4.01-2.936 6.076-6.049-3.127-11.451-6.45-16.854-9.775a537.765 537.765 0 013.25-5.712z"
        opacity="1"
      ></path>
      <path
        fill="#44DE6C"
        d="M182.906 94.568c-5.06-2.4-10.019-5.296-15.06-8.04-2.43-1.322-5.018-2.355-7.879-3.514-.47-2.047-.597-4.1-.263-6.583 3.218.886 6.032 2.098 8.72 3.542 4.845 2.602 9.615 5.343 14.416 8.026.045 2.045.09 4.09.066 6.57z"
        opacity="1"
      ></path>
      <path
        fill="#34E192"
        d="M182.917 122.567c-6.86-3.575-13.648-7.592-20.452-11.581-.691-.405-1.48-.641-2.552-.96-.413-1.73-.498-3.454-.111-5.598 3.012.683 5.653 1.602 8.073 2.927 5.055 2.769 9.993 5.751 14.98 8.646.043 2.044.086 4.088.062 6.566z"
        opacity="1"
      ></path>
      <path
        fill="#0BE5DA"
        d="M173.79 175.063c-4.836-2.505-9.387-5.17-13.965-7.79a75.774 75.774 0 00-6.388-3.251 24.082 24.082 0 013.526-6.486c6.92 4.175 13.374 8.288 19.829 12.401-.91 1.662-1.818 3.323-3.001 5.126z"
        opacity="1"
      ></path>
      <path
        fill="#00C6D3"
        d="M131.465 182.46c6.575 3.86 13.036 8.158 19.505 12.8-2.413 1.401-4.832 2.458-7.663 3.16-4.167-2.713-7.922-5.073-11.677-7.433-.093-2.696-.186-5.393-.165-8.528z"
        opacity="1"
      ></path>
      <path
        fill="#14E4C7"
        d="M159.236 146.383c5.362 2.515 10.596 5.475 15.909 8.286 1.832.97 3.862 1.565 6.17 2.331-.242 2.213-.853 4.426-2.005 6.782-4.846-2.523-9.07-5.332-13.486-7.796-2.34-1.306-5.014-2.011-7.537-2.988.284-2.076.568-4.152.949-6.615z"
        opacity="1"
      ></path>
      <path
        fill="#48DD63"
        d="M182.907 87.574c-4.868-2.258-9.638-5-14.482-7.601-2.69-1.444-5.503-2.656-8.62-3.972-.713-2.409-1.067-4.818-1.347-7.617 7.95 4.248 15.827 8.886 24.044 13.568.385 1.761.428 3.479.405 5.622z"
        opacity="1"
      ></path>
      <path
        fill="#3BE189"
        d="M182.921 115.566c-5.053-2.46-9.99-5.442-15.046-8.21-2.42-1.326-5.061-2.245-7.952-3.343-.431-2.064-.513-4.132-.46-6.628 4.196 1.664 8.281 3.71 12.312 5.857 3.48 1.854 6.899 3.825 10.708 5.747.41 2.05.457 4.096.438 6.577z"
        opacity="1"
      ></path>
      <path
        fill="#22E2AA"
        d="M47.885 52.757c-.817.965-1.634 1.931-3.08 3.02-7.014-4.162-13.399-8.447-19.784-12.732.813-1.245 1.626-2.49 3.083-3.849 4.956 2.48 9.387 4.9 13.535 7.734 2.324 1.588 4.18 3.862 6.246 5.827z"
        opacity="1"
      ></path>
      <path
        fill="#19E3BC"
        d="M40.25 66.76c-5.083-2.42-9.878-5.122-14.731-7.716-2.112-1.129-4.343-2.034-6.888-3.041.25-1.793.87-3.585 2.047-5.683 2.473.551 4.455 1.287 6.292 2.287 5.016 2.732 9.972 5.576 14.952 8.376-.47 1.846-.939 3.692-1.673 5.776z"
        opacity="1"
      ></path>
      <path
        fill="#22E3B4"
        d="M42.186 60.792c-5.244-2.609-10.2-5.453-15.216-8.185-1.837-1-3.819-1.736-6.082-2.585.951-2.219 2.25-4.445 3.84-6.824 6.678 4.132 13.063 8.417 19.794 12.73-.46 1.576-1.266 3.124-2.336 4.864zM159.464 132.392c2.252.38 4.515.929 6.469 2.026 5.465 3.068 10.803 6.364 16.552 9.575.379 1.73.397 3.455.313 5.601-5.273-2.336-10.444-5.091-15.614-7.849-2.314-1.234-4.626-2.472-7.27-3.712-.414-1.743-.497-3.483-.45-5.641z"
        opacity="1"
      ></path>
      <path
        fill="#2CE2A4"
        d="M159.455 118.395c5.205 2.34 10.271 5.117 15.363 7.849a115.926 115.926 0 007.67 3.75c.408 2.051.453 4.097.429 6.578-6.13-3.191-12.175-6.84-18.26-10.422-1.399-.823-2.933-1.415-4.735-2.115-.418-1.742-.506-3.481-.467-5.64z"
        opacity="1"
      ></path>
      <path
        fill="#34E192"
        d="M107.005 77c.83-1.862 1.66-3.724 3.114-5.754 6.028 3.442 11.431 7.05 16.835 10.66-.85 1.562-1.7 3.124-3.171 4.838-6.008-3.147-11.393-6.445-16.778-9.743z"
        opacity="1"
      ></path>
      <path
        fill="#13E5D1"
        d="M158.124 153.32c2.686.655 5.36 1.36 7.7 2.666 4.416 2.464 8.64 5.273 13.304 8.085-.331 1.922-1.024 3.697-2.027 5.67-6.764-3.917-13.219-8.03-19.872-12.406.112-1.406.422-2.55.895-4.015z"
        opacity="1"
      ></path>
      <path
        fill="#10D2DA"
        d="M72.707 135.176c5.7 3.16 11.102 6.483 16.876 9.808-.464 1.924-1.298 3.846-2.388 6.357l-18.676-9.997c1.469-2.266 2.68-4.134 4.188-6.168z"
        opacity="1"
      ></path>
      <path
        fill="#40E28D"
        d="M127.235 81.727c-5.685-3.43-11.088-7.04-16.845-10.681.36-1.67 1.074-3.307 2.092-5.642l18.892 9.704c-1.531 2.556-2.695 4.498-4.14 6.619z"
        opacity="1"
      ></path>
      <path
        fill="#32E29F"
        d="M106.734 77.187c5.656 3.112 11.04 6.41 16.77 9.736-2.041 4.98-6.953 2.77-11.099 3.845-3.487-2.629-6.559-5.188-9.995-7.75 1.108-1.883 2.581-3.764 4.324-5.83z"
        opacity="1"
      ></path>
      <path
        fill="#26E2A8"
        d="M144.662 112.586c-7.248-3.971-14.395-8.372-21.603-13.101 3.302-.374 6.663-.42 10.541-.073 4.004 2.466 7.492 4.54 10.98 6.613.06 2.044.121 4.088.082 6.561z"
        opacity="1"
      ></path>
      <path
        fill="#2CE2A4"
        d="M48.197 52.661c-2.379-1.87-4.234-4.143-6.558-5.731-4.148-2.835-8.579-5.255-13.244-7.882 1.117-1.9 2.587-3.768 4.353-5.772.608.923.584 2.512 1.287 2.96 6.318 4.029 12.765 7.857 19.54 11.745-1.446 1.528-3.256 3.057-5.378 4.68z"
        opacity="1"
      ></path>
      <path
        fill="#38DF7C"
        d="M66.904 33.565c-6.23-3.334-12.394-7.101-18.71-11.163a27.463 27.463 0 017.47-3.006c3.998 2.755 7.584 5.18 11.17 7.604.045 2.043.09 4.087.07 6.565z"
        opacity="1"
      ></path>
      <path
        fill="#00BDCD"
        d="M131.497 191.427c3.888 1.92 7.643 4.28 11.448 6.969-3.55 1.412-7.15 2.496-11.582 3.83 0-3.906 0-7.133.134-10.8z"
        opacity="1"
      ></path>
      <path
        fill="#32E6BE"
        d="M111.61 99.179c1.67 1.8 2.605 3.952 4.24 5.143 4.89 3.56 10.082 6.707 15.088 10.114.858.584 1.384 1.654 2.086 2.837-1.387.386-2.797.437-4.537.388-1.688-1.777-2.768-3.841-4.458-5.062-4.893-3.535-10.06-6.69-15.047-10.1-.845-.578-1.33-1.68-2-2.884 1.392-.404 2.802-.464 4.628-.436z"
        opacity="1"
      ></path>
      <path
        fill="#3CDF74"
        d="M66.901 26.546c-3.653-1.97-7.239-4.395-10.86-7.165 3.35-1.367 6.735-2.387 10.928-3.65 0 3.915 0 7.138-.068 10.815z"
        opacity="1"
      ></path>
      <path
        fill="#23E0D5"
        d="M16.109 64.287c6.121 2.978 12.14 6.265 18.164 9.547 1.295.705 2.6 1.392 4.249 2.12.395.793.442 1.553.417 2.688-5.462-2.583-10.834-5.572-16.248-8.485-2.103-1.131-4.298-2.09-6.798-3.113-.193-.806-.039-1.628.216-2.757z"
        opacity="1"
      ></path>
      <path
        fill="#32E29F"
        d="M144.68 105.59c-3.588-1.639-7.076-3.712-10.626-6.115 3.355-.33 6.772-.33 10.726-.33 0 2.18 0 4.094-.1 6.444zM90.45 71.705c-2.363-.81-4.755-1.95-7.3-3.396.974-1.133 2.102-1.96 3.466-2.96 1.41 2.235 2.607 4.13 3.834 6.356z"
        opacity="1"
      ></path>
      <path
        fill="#32E6BE"
        d="M99.73 116.977c1.414.066 2.543.183 3.91.537.249.441.26.644.33 1.145-1.669-.147-3.397-.593-5.126-1.038.054-.136.076-.305.172-.397.107-.102.282-.134.713-.247z"
        opacity="1"
      ></path>
    </svg>
  );
};
